export const TOTAL_WIDTH_SLITTING_START = 'TOTAL_WIDTH_SLITTING'

const totalWidthWithSlittingAction = width => {
  return {
    type: TOTAL_WIDTH_SLITTING_START,
    payload: width,
  }
}
export default totalWidthWithSlittingAction
